import { format, isAfter, isValid, isWithinInterval, parseISO } from 'date-fns'
import utcToZonedTime from 'date-fns-tz/utcToZonedTime'
import { NurtureValue } from './getNurture'
import { getNurtureProgramSettings } from './getNurtureProgramSettings'

export function isNurtureServiceEnabled(
  nurtureSettings: NurtureValue | false | null | undefined,
  timeZone = 'UTC',
  now: Date = new Date()
): boolean {
  if (!nurtureSettings) {
    return false
  }

  if (!nurtureSettings.startDate || !nurtureSettings.endDate) {
    return false
  }

  const start = parseISO(nurtureSettings.startDate)
  const end = parseISO(nurtureSettings.endDate)

  if (!isValid(start) || !isValid(end)) {
    return false
  }

  const zonedStart = utcToZonedTime(start, timeZone)
  const zonedEnd = utcToZonedTime(end, timeZone)
  const zonedNow = utcToZonedTime(now, timeZone)

  return isWithinInterval(zonedNow, { start: zonedStart, end: zonedEnd })
}

export function isNurtureServiceEnabledForChannel(
  channelFeatures: any,
  timeZone = 'UTC',
  now: Date = new Date()
): boolean {
  return isNurtureServiceEnabled(
    getNurtureProgramSettings(channelFeatures),
    timeZone,
    now
  )
}

export function isNurtureProgramEnded(
  nurtureSettings: NurtureValue | false | null | undefined,
  timeZone = 'UTC',
  now: Date = new Date()
): boolean {
  if (!nurtureSettings) {
    return false
  }

  if (!nurtureSettings.endDate) {
    return false
  }

  const end = parseISO(nurtureSettings.endDate)

  if (!isValid(end)) {
    return false
  }

  const zonedEnd = utcToZonedTime(end, timeZone)
  const zonedNow = utcToZonedTime(now, timeZone)

  return isAfter(zonedNow, zonedEnd)
}

export function formatNurtureProgramDate(
  date: string,
  timeZone = 'UTC',
  dateFormat = 'MMMM d, yyyy'
): string {
  const parsed = parseISO(date)

  if (!isValid(parsed)) {
    return ''
  }

  return format(utcToZonedTime(parsed, timeZone), dateFormat)
}
